import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoClassificacaoFaturamentoMultiselectComponent } from './novo-classificacao-faturamento-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoClassificacaoFaturamentoMultiselectComponent],
  exports: [NovoClassificacaoFaturamentoMultiselectComponent]
})
export class NovoClassificacaoFaturamentoMultiselectModule {}
